import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

import FullPageSpinner from '@/components/feedback/FullPageSpinner'
import { BidOverviewDrawerContextProvider } from '@/features/bidding/contexts/BidOverviewDrawerContextProvider'
import type { BidOfferData } from '@/features/bidding/hooks/useBidOfferData'
import { useBidOfferData as useBidOfferDataHook } from '@/features/bidding/hooks/useBidOfferData'

const BidOfferDataContext = createContext<BidOfferData | undefined>(undefined)

export function useBidOfferDataContext(): BidOfferData {
  const ctx = useContext(BidOfferDataContext)
  if (!ctx) throw new Error('useBidOfferDataContext must be used within a BidOfferDataProvider')
  return ctx
}

export function BidOfferDataProvider({ children }: Readonly<{ children: ReactNode }>) {
  const bidOfferDataResult = useBidOfferDataHook()

  // Show full page spinner while loading
  if (bidOfferDataResult.isLoading) {
    return <FullPageSpinner />
  }

  return (
    <BidOfferDataContext.Provider value={bidOfferDataResult.data}>
      <BidOverviewDrawerContextProvider>{children}</BidOverviewDrawerContextProvider>
    </BidOfferDataContext.Provider>
  )
}
